import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import TextBlock from "../textBlock";


const MarkdownBlock = ({ body }) => {
	return (
		<TextBlock>
			<Markdown remarkPlugins={[remarkGfm]}>{body}</Markdown>
		</TextBlock>
	);
};

export default MarkdownBlock;
